import(/* webpackMode: "eager" */ "/app/.yarn/__virtual__/next-virtual-e29b8b924f/0/cache/next-npm-14.2.25-cd023f1b24-fa0cd12ba7.zip/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/webapp/app/pwa/(main-layout)/team/[teamId]/(simple-layout)/game/[gameId]/components/ShareMatchButton.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["TickerButton"] */ "/app/webapp/app/pwa/(main-layout)/team/[teamId]/(simple-layout)/game/[gameId]/components/TickerButton.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/webapp/app/pwa/components/Button.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["EventCardAttendancePicker"] */ "/app/webapp/app/pwa/components/event/EventCard/EventCardAttendancePicker.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/webapp/app/pwa/components/Image.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/webapp/app/pwa/components/layout/NavBackButton.tsx");
;
import(/* webpackMode: "eager" */ "/app/webapp/app/pwa/components/match/Match.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["TabBarTab"] */ "/app/webapp/app/pwa/components/TabBar.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["TeamName"] */ "/app/webapp/app/pwa/components/team/TeamName.tsx");
;
import(/* webpackMode: "eager" */ "/app/webapp/assets/icon/chevron-right.svg");
;
import(/* webpackMode: "eager" */ "/app/webapp/assets/icon/default-player.png");
;
import(/* webpackMode: "eager" */ "/app/webapp/assets/icon/edit.svg");
;
import(/* webpackMode: "eager" */ "/app/webapp/assets/icon/futbol-regular.svg");
;
import(/* webpackMode: "eager" */ "/app/webapp/assets/icon/plus.svg");
;
import(/* webpackMode: "eager" */ "/app/webapp/assets/icon/ticker/red-card.svg");
;
import(/* webpackMode: "eager" */ "/app/webapp/assets/icon/ticker/substitute.svg");
;
import(/* webpackMode: "eager" */ "/app/webapp/assets/icon/ticker/yellow-card.svg");
;
import(/* webpackMode: "eager" */ "/app/webapp/assets/icon/ticker/yellow-red-card.svg");
